import { post } from './api-request'

export default (file, url) => {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('MAX_FILE_SIZE', '10485760')
  return post(url, formData)
}
